import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Aos from "aos";
import "aos/dist/aos.css";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getContactInfo, submitContactMessages } from "../redux/actionCreator";
import { contactInfo_details, contactInfo_path } from "../redux/commonReducer";
import { API_BASE_IMAGE_URL } from "../constants/configuration";
import { useForm } from "react-hook-form";
import Toast from "react-bootstrap/Toast";
import "./contact.css";
import { toast } from "react-toastify";
import Head from "../constants/Head";
function Contact() {
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm();
  const { t } = useTranslation();
  const [language, setLanguage] = useState("");
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  //

  const [textareaheight, setTextareaheight] = useState("");
  const [captchaValue, setCaptchaValue] = useState("");
  const [value, setValue] = useState("");
  // DATAS
  const contactInfo = useSelector(contactInfo_details);
  const contactInfoPath = useSelector(contactInfo_path);

  const [disableButtons, setDisabledButtons] = useState([]);

  const addToDisabled = (btn) => {
    setDisabledButtons([...disableButtons, btn]);
  };

  const removeFromDisabled = (btn) => {
    setDisabledButtons(disableButtons?.filter((e) => e != btn));
  };

  useEffect(() => {
    dispatch(getContactInfo());
  }, []);

  useEffect(() => {
    const lang = localStorage.getItem("lang");
    setLanguage(lang);
  }, [localStorage.getItem("lang")]);

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  useEffect(() => {
    createCaptcha();
  }, []);

  const validateCaptcha = () => {
    return captchaValue == value;
  };

  const onSubmit = (data) => {
    console.log(validateCaptcha());
    if (validateCaptcha()) {
      // toast.success("Captcha Valid", {
      //   position: "bottom-center",
      //   autoClose: 3000
      // })
      addToDisabled("submitButton");
      const formData = new FormData();
      formData.append("name", data?.name);
      formData.append("email", data?.email);
      formData.append("title", data?.title);
      formData.append("message", data?.description);
      dispatch(
        submitContactMessages(formData, (res) => {
          if (res === true) {
            setShow(true);
            createCaptcha();
            setValue("");
          }
          reset();
          removeFromDisabled("submitButton");
        })
      );
    } else {
      toast.error(t("Invalid Captcha"), {
        position: "bottom-center",
        autoClose: 3000,
      });
    }
  };

  function autoHeight(e) {
    setTextareaheight(e.target.scrollHeight);
  }

  function createCaptcha() {
    //clear the contents of captcha div first
    let code;
    document.getElementById("captcha").innerHTML = "";
    let charsArray =
      "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@!#$%^&*";
    let lengthOtp = 6;
    let captcha = [];
    for (let i = 0; i < lengthOtp; i++) {
      //below code will not allow Repetition of Characters
      var index = Math.floor(Math.random() * charsArray.length + 1); //get the next character from the array
      if (captcha.indexOf(charsArray[index]) == -1)
        captcha.push(charsArray[index]);
      else i--;
    }
    let canv = document.createElement("canvas");
    canv.id = "captcha";
    canv.width = 100;
    canv.height = 50;
    let ctx = canv.getContext("2d");
    ctx.font = "25px Georgia";
    ctx.strokeText(captcha.join(""), 0, 30);
    //storing captcha so that can validate you can save it somewhere else according to your specific requirements
    code = captcha.join("");
    document.getElementById("captcha").appendChild(canv); // adds the canvas to the body element
    setCaptchaValue(code);
    console.log(code);
  }
  return (
    <>
      <Head
        title={t("html_title.contact")}
        metatitle={t("html_title.contact")}
        metaDescription={t("html_title.contact")}
      />
      <Header />
      <section className="innerpage__header">
        <div className="container">
          <div className="banner__image">
            {contactInfo?.map((ele) => {
              return (
                <img
                  src={
                    API_BASE_IMAGE_URL +
                    contactInfoPath +
                    "/" +
                    ele?.banner_name
                  }
                  className="w-100 about-img sm-contact"
                  alt=""
                />
              );
            })}
            <div className="contents">
              <div className="row">
                <div className="col-md-12 p-0">
                  <div className="header__title bottomPad sm-height">
                    <h2>{t("main_title.contact")}</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="Contact__informations bg-default">
        <div className="container">
          <div className="contact__info mb-5">
            <div className="row justify-content-center">
              {contactInfo?.map((ele) => {
                return (
                  <div className="col-md-5 mb-5">
                    <div className="contact__grid" data-aos="fade-right">
                      <h4>{t("location")}</h4>
                      <p
                        dangerouslySetInnerHTML={{
                          __html:
                            language == "en"
                              ? ele?.address_en
                              : ele?.address_ar,
                        }}
                      ></p>
                    </div>
                    <div className="contact__grid" data-aos="fade-right">
                      <h4>{t("contact_details")}</h4>
                      <p className="mb-0">
                        <a href={`tel:${ele?.telephone}`} rel="noreferrer">
                          Tel: +{ele?.telephone}
                        </a>
                      </p>
                      <p className="mt-0">
                        {" "}
                        <a href={`mailto:${ele.email}`} rel="noreferrer">
                          {language == "en" ? ele?.email : ele?.email}
                        </a>
                      </p>
                    </div>
                  </div>
                );
              })}
              <div className="col-md-5 mb-5">
                <div className="contact__grid" data-aos="fade-left">
                  <h4>{t("send_message")}</h4>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="contact__form">
                      <div className="form-group">
                        {/* {
                          console.log(t("name_should_alphabets"))
                        } */}
                        {/* {console.log(errors)} */}
                        <input
                          type="text"
                          // {...register("name", { required: true })}
                          {...register("name", {
                            required: true,
                            pattern: {
                              value: /^[a-zA-Zء-ي ]*$/,
                              message: "name_should_alphabets",
                            },
                          })}
                          aria-invalid={errors.name ? "true" : "false"}
                          className="form-control"
                          placeholder={t("name")}
                        />
                        {errors.name?.type === "pattern" && (
                          <span className="formError">{t(errors.name?.message)}</span>
                        )}
                        {errors.name?.type === 'required' && (
                          <span className="formError">
                            {errors.name?.message != ""
                              ? errors.name?.message
                              : t("name_required")}
                          </span>
                        )}
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          {...register("email", {
                            required: true,
                            pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          })}
                          placeholder={t("email")}
                        />
                        {errors.email?.type === "required" && (
                          <span className="formError">{t("email_required")}</span>
                        )}
                        {errors.email?.type === "pattern" && (
                          <span className="formError">
                            {t("invalid_email_format")}
                          </span>
                        )}
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          // {...register("title", { required: true })}
                          {...register("title", {
                            required: true,
                            pattern: {
                              value: /^[a-zA-Z0-9ء-ي. ]*$/,
                              message: t("invalid_characters"),
                            },
                          })}
                          aria-invalid={errors.title ? "true" : "false"}
                          placeholder={t("title")}
                        />
                        {/* {errors.title?.type === "required" && (
                          <span className="formError">Title is required</span>
                        )} */}
                        {errors.title && (
                          <span className="formError">
                            {errors.title?.message != ""
                              ? errors.title?.message
                              : t("title_required")}
                          </span>
                        )}
                      </div>
                      <div className="form-group">
                        <textarea
                          className="form-control"
                          // {...register("description", { required: true })}
                          {...register("description", {
                            required: true,
                            pattern: {
                              value: /^[a-zA-Z0-9ء-ي .؟،,-:!"?()'’“”‘’\n]*$/,
                              message: t("invalid_characters"),
                            },
                          })}
                          aria-invalid={errors.description ? "true" : "false"}
                          placeholder={t("message")}
                          // onChange={autoHeight}
                          rows={1}
                          style={{ height: `${textareaheight}px` }}
                        ></textarea>
                        {/* {errors.description?.type === "required" && (
                          <span className="formError">Message is required</span>
                        )} */}
                        {errors.description && (
                          <span className="formError">
                            {errors.description?.message != ""
                              ? errors.description?.message
                              : t("message_required")}
                          </span>
                        )}
                      </div>
                      <div className="form-group captchaSection d-flex">
                        <div id="captcha"></div>
                        <input
                          type="text"
                          placeholder={t("enter_captcha")}
                          id="cpatchaTextBox"
                          className="form-control"
                          value={value}
                          onChange={(e) => setValue(e.target.value)}
                        />
                        {/* <button type = "button" onClick={()=>createCaptcha()}>resend</button> */}
                        <i
                          class="bi bi-arrow-repeat"
                          onClick={() => (createCaptcha(), setValue(""))}
                        ></i>
                      </div>
                      <button className="btn btn-primary" type="submit" disabled={disableButtons?.includes("submitButton")}>
                        {t("send")}
                      </button>
                    </div>
                    <Toast
                      onClose={() => setShow(false)}
                      show={show}
                      delay={3000}
                      autohide
                    >
                      <Toast.Body>{t("success_mesaage")}</Toast.Body>
                    </Toast>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Contact;
